import CollectionTable from "../../compoments/shopper/collection/CollectionTable";

export default function Collections() {
    return (<CollectionTable/>);
}